import { useEffect } from 'react';
import classNames from 'classnames/bind';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

const NoWLData = ({ changeIsWatchlistUpdatedValue }) => {
  useEffect(() => {
    changeIsWatchlistUpdatedValue(true);
  }, []);

  return (
    <div className={Styles.no_wl_data}>
      <div className={Styles.no_data_filter_bar}>
        <div className={Styles.no_data_filter_btn}>
          <div className={cx('no_data_default', 'filter_btn')} />
          <div className={cx('no_data_default', 'filter_btn')} />
        </div>
        <div className={Styles.no_data_layout}>
          <div className={cx('no_data_default', 'layout')} />
          <div className={cx('no_data_default', 'switch')} />
          <div className={cx('no_data_default', 'switch')} />
          <div className={cx('no_data_default', 'switch')} />
        </div>
      </div>
      <div className={cx('no_data_default', 'row')} />
      <div className={cx('no_data_default', 'row')} />
      <div className={cx('no_data_default', 'row')} />
    </div>
  );
};

export default NoWLData;
